/**
 * Gets the base URL of the frontend application.
 *
 * Must be set via VITE_FRONTEND_URL environment variable.
 *
 * @returns The base URL of the application (e.g., https://app.example.com or http://localhost:5173)
 * @throws Error if VITE_FRONTEND_URL is not set
 */
export function getAppBaseUrl(): string {
  const envUrl = import.meta.env.VITE_FRONTEND_URL

  if (!envUrl) {
    throw new Error('VITE_FRONTEND_URL environment variable is required')
  }

  return envUrl
}
